'use strict';

var responsiveStyle = require('./responsive-style');
module.exports = responsiveStyle('flexDirection');


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/styled-system/dist/flex-direction.js
// module id = 4485
// module chunks = 168707334958949